import { sidebarSelectFieldStyle } from "./sidebarSelectFieldStyle";

export const selectFieldStyle = {
  control: (base, state) => ({
    ...base,
    minHeight: "3em",
    maxHeight: "3em",
    borderRadius: "0.75em",
    boxShadow:
      "0.8px 1.6px 3.2px 0px rgba(0, 0, 0, 0.02),2.4px 4.8px 6.4px 0px rgba(0, 0, 0, 0.02),5.6px 11.2px 8px 0px rgba(0, 0, 0, 0.01)",
    backgroundColor: "#fcfafc",
    borderColor: state.isFocused ? "#6a18ed" : "transparent",
    "&:hover": {
      border: "1px solid #6a18ed",
    },
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "15em",
    "::-webkit-scrollbar": {
      width: ".3em",
      height: ".3em",
    },
    "::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#b7b5ba",
      borderRadius: "100px",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#6a18ed",
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: "1050",
    borderRadius: ".75em",
    overflow: "hidden",
    padding: ".75em",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: "1050",
  }),
  option: (base, state) => ({
    ...base,
    borderRadius: "0.5em",
    marginBottom: ".25em",
    marginTop: ".25em",
    backgroundColor: state.isSelected ? "#6a18ed" : "transparent",
    color: state.isSelected ? "#fcfcfc" : "#6b6970",
    "&:hover": {
      color: "#222024",
      backgroundColor: "rgb(106, 24, 237, 0.3)",
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    textWrap: "nowrap !important",
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    transition: "all .3s",
    color: state.isFocused ? "#6a18ed" : "#6b6970",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      opacity: "0.5",
    };
  },
};

export const inventoryModalPricesStatsSelectFieldStyle = {
  control: (base, state) => ({
    ...base,
    height: "3em",
    width: "14em",
    backgroundColor: "transparent",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "10em",
    "::-webkit-scrollbar": {
      width: ".3em",
      height: ".3em",
    },
    "::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#b7b5ba",
      borderRadius: "100px",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#6a18ed",
    },
  }),
  menu: (base) => ({
    ...base,
    background: "#2f2f2f",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#6a18ed" : "transparent",
    color: state.isSelected ? "#fcfcfc" : "#9e9e9e",
    "&:hover": {
      color: "#fcfcfc",
      backgroundColor: "transparent",
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    textWrap: "nowrap !important",
    color: "#fcfcfc",
  }),
};

export const insertVariableSelectFieldStyle = {
  ...sidebarSelectFieldStyle,
  control: (base, state) => ({
    ...sidebarSelectFieldStyle.control(base, state),
    border: "0.5px solid #915E95",
    "&:hover": {
      border: "0.5px solid #915E95",
    },
  }),
  placeholder: (defaultStyles, state) => {
    return {
      ...sidebarSelectFieldStyle.placeholder(defaultStyles, state),
      color: "#915E95",
      fontSize: "0.9em",
    };
  },
  dropdownIndicator: (base, state) => ({
    ...sidebarSelectFieldStyle.dropdownIndicator(base, state),
    color: "#915E95",
    "&:hover": {
      color: "#915E95",
    },
  }),
  menu: (base, state) => ({
    ...sidebarSelectFieldStyle.menu(base, state),
    width: "unset",
  }),
};

export const insertVariableShopifyField = {
  ...sidebarSelectFieldStyle,
  control: (base, state) => ({
    ...sidebarSelectFieldStyle.control(base, state),
    border: "0.5px solid #0062FF",
    "&:hover": {
      border: "0.5px solid #0062FF",
    },
  }),
  placeholder: (defaultStyles, state) => {
    return {
      ...sidebarSelectFieldStyle.placeholder(defaultStyles, state),
      color: "#0062FF",
      fontSize: "0.9em",
      fontStyle: "italic",
    };
  },
  dropdownIndicator: (base, state) => ({
    ...sidebarSelectFieldStyle.dropdownIndicator(base, state),
    color: "#0062FF",
    "&:hover": {
      color: "#0062FF",
    },
  }),
  menu: (base, state) => ({
    ...sidebarSelectFieldStyle.menu(base, state),
    width: "unset",
  }),
};

export const multiSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "3em",
    borderRadius: "0.75em",
    boxShadow:
      "0.8px 1.6px 3.2px 0px rgba(0, 0, 0, 0.02),2.4px 4.8px 6.4px 0px rgba(0, 0, 0, 0.02),5.6px 11.2px 8px 0px rgba(0, 0, 0, 0.01)",
    backgroundColor: "#fcfafc",
    borderColor: state.isFocused ? "#6a18ed" : "transparent",
    "&:hover": {
      border: "1px solid #6a18ed",
    },
    height: "auto",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "15em",
    "::-webkit-scrollbar": {
      width: ".3em",
      height: ".3em",
    },
    "::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#b7b5ba",
      borderRadius: "100px",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#6a18ed",
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: "1050",
    borderRadius: ".75em",
    overflow: "hidden",
    padding: ".75em",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: "1050",
  }),
  option: (base, state) => ({
    ...base,
    borderRadius: "0.5em",
    marginBottom: ".25em",
    marginTop: ".25em",
    backgroundColor: state.isSelected ? "#6a18ed" : "transparent",
    color: state.isSelected ? "#fcfcfc" : "#6b6970",
    "&:hover": {
      color: "#222024",
      backgroundColor: "rgb(106, 24, 237, 0.3)",
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    textWrap: "nowrap !important",
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    transition: "all .3s",
    color: state.isFocused ? "#6a18ed" : "#6b6970",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      opacity: "0.5",
    };
  },
};
